<template>

            <div class="row no-wrap order_line justify-center">
                <div class="col-1 self-center buttonContainer row ellipsis q-ml-xs"  v-bind:class="{'justify-center': isLock }">
                    <!-- Блок без блокировки -->
                    <div v-if='!isLock'>
                        <div class="icon_button self-center" @click="editOrder">
                            <q-icon name="edit" color="light-blue-10" size="20px" />
                        </div>
            
                        <div class="icon_button self-center" @click="deleteOrder">
                            <q-icon name="delete_outline" color="grey-8" size="20px" />
                        </div>
                    </div>
                    <!-- Блок с блокировкой  -->
                    <div v-if='isLock'>
                        <q-icon name="lock" color="red-10"/>
                    </div>
                </div>
                <div class="col-1 self-center order_num ellipsis"> {{ order.id }}</div>
                <div class="col-md-1 col-lg-1 self-center contragent col-sm-3 col-xs-2 "> {{ getContragentName }}</div>
                
                <div class="col-md-1 col-lg-1 self-center gt-sm contragent ellipsis q-mr-sm col-xs-3 col-sm-3"> {{ NiceDate }}</div>
                <div class="col-md-2 col-lg-2 self-center contragent ellipsis col-xs-7 col-sm-7"> {{ ManagerName }}</div>
                <div 
                    class="gt-sm self-center col-6" 
                    style=" overflow: hidden; text-overflow:ellipsis"
                    @click="edit">
                        <span v-if="!editMode"> {{ comment }}</span>
                        <span v-if="editMode">
                                <input type=text
                                    v-model="order.comment"
                                    v-on:blur="doneEdit"
                                    @keyup.enter="doneEdit"
                                    @keyup.esc="cancelEdit"
                                    class="comment-input"
                                    v-focus
                                /> 
                        </span>
                    </div>
            </div>
</template>


<script>
/* eslint-disable */
    const month = [
        'янв', "фев", "мар", "апр", "мая", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"
    ];

    export default {

        props:{
            order : {
                type: Object,
                requered: true,
            },
            orderComment : '',
        },

        data () {
            return {
                editMode: false,            
                'id' : this.order.id,
                'caсheComment' : this.order.comment,
            }
        },

        directives: {
            focus: {
                // определение директивы
                inserted: function (el) {
                el.focus()
                }
            }
        },

       methods :{
           editOrder() {
               //пытаемся заблокировать запись - а только потом редактируем
               this.$store.dispatch('lockOrder', this.order.id)
               .then(() => eventBus.$emit('editOrder', this.order))
               .catch(error=>{
                   console.log(error);
                   this.$admns.showNotify('Не удалось заблокировать запись','error','Сообщение системы');
               });
           },

           deleteOrder() {
               eventBus.$emit('deleteOrder', this.order);
           },

           edit() {
               if (!this.editMode) {
                   this.cacheComment = this.comment;
                   this.editMode = true;
               }
           },
           
           cancelEdit() {
               this.comment = this.caсheComment;
               this.editMode = false;
           },

           doneEdit() {
                this.editMode = false;
                this.$store.dispatch('updateOrder', {
                          id : this.id,
                          comment : this.comment,
                });
           },
 
       },

       created() {
        },
        computed: { 
            isLock() {
                return this.order.lock_at != null;
            },
            getContragentName() {
                var q = this.$store.getters.getContragentById(this.order.contragent);
                if (q==undefined) return '';
                return this.$store.getters.getContragentById(this.order.contragent).name;
              
            },

            NiceDate() {
                var st = this.order.created_at;
                if (st == undefined) return '';
                var m = st.substr(5,2) - 1;
                return st.substr(5,2)*1 + " " + month[m] + st.substr(10,6);
            },

            ManagerName() {
                var q = this.$store.getters.getUserById(this.order.manager);
                if (q==undefined) return '';
                return q.name+' '+q.surname;
            },

            comment() {
               return this.order.comment; 
            }

        }
    }

</script>

<style  lang="scss" scoped>

    .order_line {
        background: rgb(231, 231, 231);
        margin: 0px;
        padding : 6px;
        border : 1px solid;
        border-top-color :rgb(211, 211, 211); 
        border-left-color :rgb(211, 211, 211); 
        border-bottom-color: darkgray;
        border-right-color: darkgray;

        font-family: Arial, sans-serif;
        font-size: 15px;
        // display: flex;
        height: 35px;
        width : 100%;
    

        &:hover {
            background: lightgreen;
        }
        .icon_button {
            width:25px;
            cursor: pointer;
            margin-left: 5px;
            float : left;
        }        
        .order_num {
            font-weight: bold;
        }
        .contragent{
            font-weight:normal;
            text-overflow: clip;
        }
        .date_field {
            font-size: 15px;
        }
        .managerName_field {
            font-size: 15px;

            min-width: 180px;
        }
        .right_container {
            justify-content : flex-end;
            width : 100%;
            display : flex;
            overflow: hidden;
        }
        .comment_field {
            font-size: 15px;
            min-width: 250px;
            overflow: hidden;
        }
        .buttonContainer {
            min-width : 60px;
            // background: white;
            // border-left: 1px solid black;
            // border-right: 1px solid black;
        }
        .takeIco {
            width:18px;
        }
        .comment-input{
            width:100%;
            background: white;
           // border : 1px solid lightblue;            
            box-shadow: 5 5 5px rgba(0, 81, 255, 0.5); /* Параметры тени */
        }
    }
    

</style>

